export default __webpack_public_path__ + "static/media/lola-with-animation.2463159f.gif";